import { Pagination } from 'lib/types/shared';
import { Dispatch } from 'redux';

export interface BaseOperation {
  id: number;
  businessIdentifier: string;
  createdAt: string;
  updatedAt: string;
}

export interface OperationTypeConfig {
  key: string;
  label: string;
  apiEndpoint: string;
  tableHeaders: Array<{
    label: string;
    key: string;
    type?: string;
  }>;
  getLabel: (operationId: string) => string;
  fetchData: (
    dispatch: Dispatch,
    page: number,
    pageSize: number,
    businessIdentifier: string | undefined,
  ) => Promise<{ data: BaseOperation[]; pagination: Pagination }>;
}

export interface OperationValue {
  enabled: boolean;
  operationType?: string;
  operation?: BaseOperation;
}

// Operation type registry
export const OPERATION_TYPES: Record<string, OperationTypeConfig> = {
  'warranty-request': {
    key: 'warranty-request',
    label: 'Garantías',
    apiEndpoint: 'internal/sgrWarrantyRequest',
    tableHeaders: [
      {
        label: 'ID',
        key: 'id',
        type: 'numeric-id',
      },
      {
        label: 'Tipo',
        key: 'translatedType',
      },
      {
        label: 'Cliente',
        key: 'businessName',
      },
      {
        label: 'Estado',
        key: 'translatedStatus',
        type: 'status',
      },
      {
        label: 'Monto Cotizado',
        key: 'quotedAmount',
        type: 'money',
      },
      {
        label: 'Moneda',
        key: 'quotedCurrency',
      },
      {
        label: 'Costo de emisión',
        key: 'premium',
        type: 'money',
      },
    ],
    getLabel: (operationId: string) => `Garantía ${operationId}`,
    fetchData: async (dispatch, page, pageSize, businessIdentifier) => {
      const { getAllSGRWarrantyRequests } = await import('lib/api/sgr');
      const query = `page=${page}&pageSize=${pageSize}&businessIdentifier=${businessIdentifier}`;
      return await getAllSGRWarrantyRequests(dispatch, query);
    },
  },
};
